import { useState } from "react";
import { subscriptionService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { ITrade } from "@miplatform/types";

export const useRedTagDrawerViewModel = () => {
  const stateManager = useComponentState();
  const [trades, setTrades] = useState<ITrade[]>([]);

  const getTrades = () => {
    stateManager.run(async () => {
      const response = await subscriptionService.trades.getAll();
      if (response.status === HTTP_STATUSES.OK) {
        setTrades(response.data);
      }
    });
  };

  return {
    trades,
    getTrades,
  };
};
